<template>
  <BoxWithTitle class="my-4">
    <template #header>
      <v-toolbar-title>
        {{ $t('profile.title') }}
      </v-toolbar-title>
    </template>

    <template #icons>
      <v-btn
        icon
        @click="onClickToggle"
      >
        <v-icon>
          {{ formEditable ? 'mdi-close' : 'mdi-pencil-outline' }}
        </v-icon>
      </v-btn>
    </template>

    <template #content>
      <v-progress-linear
        v-if="loading"
        indeterminate
      />
      <form v-else>
        <ProfileForm
          ref="mainForm"
          :populateWith="updatedData"
          :langs="langs"
          :isEditable="formEditable"
          @dirtyChanged="isFormDirty = $event"
          @validChanged="isFormValid = $event"
          @sendData="updateData"
        />
        <v-row
          v-if="formEditable"
          align="center"
          justify="end"
          class="mr-1"
        >
          <v-btn
            :disabled="!isFormValid || !isFormDirty"
            type="submit"
            color="secondary"
            @click.prevent="onClickUpdate"
          >
            {{ $t('forms.btn.save') }}
          </v-btn>
        </v-row>
      </form>
    </template>
  </BoxWithTitle>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import { mapActions } from 'vuex';
import ProfileForm from '@/components/profile/ProfileForm.vue';
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';
import FormPageMixin from '@/mixins/FormPageMixin';

export default {
    components: {
        ProfileForm,
        BoxWithTitle,
    },
    mixins: [
        FormPageMixin,
    ],
    data() {
        return {
            loading: false,
            profile: {},
        };
    },
    computed: {
        defaultData() {
            return this.profile;
        },
        langs() {
            return [
                {
                    key: 'en',
                    name: 'English',
                },
                {
                    key: 'fr',
                    name: 'Français',
                },
            ];
        },
    },
    async created() {
        await this.getProfile();
        this.initFormData();
    },
    methods: {
        ...mapActions({
            setLang: 'setLang',
        }),
        async getProfile() {
            this.loading = true;
            const { data } = await this.$rq.getProfile();
            this.profile = data.profile;

            Object.keys(this.langs).forEach(lang => {
                if (data.preferences.locale === this.langs[lang].key) {
                    this.profile.lang = this.langs[lang].key;
                }
            });
            this.loading = false;
        },
        preparePayload() {
            if (!isEmpty(this.updatedData.phoneNumber) && !this.updatedData.phoneNumber.valid) {
                return this.$toasted.global.toast_error({
                    message: this.$t('profile.phoneError'),
                });
            }
            return {
                profile: {
                    firstName: this.updatedData.firstName,
                    lastName: this.updatedData.lastName,
                    phoneNumber: this.updatedData.phoneNumber,
                },
                preferences: {
                    locale: this.updatedData.lang,
                },
            };
        },
        async onClickUpdate() {
            const requestPayload = this.preparePayload();
            const response = await this.$rq.updateProfile('me', requestPayload);
            this.profile = cloneDeep(this.updatedData);

            this.cancelModifications();
            this.$toasted.global.toast_success({
                message: this.$t('profile.profileUpdated'),
            });

            if (response.status === 200) {
                this.setLang(requestPayload.lang);
            }
        },
    },
};
</script>
